import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Route } from 'react-router-dom';
import SendProposal from 'components/merchant/bookings/send-proposal'
import EditProposal from 'components/merchant/bookings/edit-proposal'
import ThreadList from 'components/merchant/messages/thread-list';
import Conversations from 'components/merchant/messages/conversation'

const Threads = ({ match }) => {
  const [messageData, setMessageData] = useState({ action: 'message' })
  const action = messageData.action

  const handleMessageOrProposal = (data = {}) => {
    data.action = data.action || 'message'
    setMessageData(data)
  }

  return (
    <>
      {action === 'message' && <div className="h-vh-msg flex-1 flex w-full">
        <ThreadList params={match.params} />
        <Route
          path={`${match.path}/:id/conversation`}
          render={props => <Conversations {...props} handleMessageOrProposal={handleMessageOrProposal} />} />
      </div>}
      {action === 'send-proposal' && <SendProposal data={messageData} handleClose={handleMessageOrProposal} closeTitle={messageData.closeTitle}/>}
      {action === 'edit-proposal' && <EditProposal data={messageData} handleClose={handleMessageOrProposal} closeTitle={messageData.closeTitle} />}
    </>
  );
}

Threads.propTypes = {
  match: PropTypes.object.isRequired,
};

export default withRouter(Threads);
